<template>
  <div class="input-freetext-container input-freetext-small">
    <input v-model="innerValue" type="text" class="form-control" />
  </div>
</template>

<script>
import slider from 'vue3-slider';

import AnimatingNumber from '@/components/AnimatingNumber/AnimatingNumber';
import InputComponent from '../InputComponent';

export default {
  name: 'InputFreetextSmall',
  extends: InputComponent,
  props: {
    modelValue: {
      type: [Number, Array, String],
      required: false,
      default: 0,
    },
  },
  emits: ['update:modelValue'],
  data() {
    return {
      innerValue: '',
    };
  },
  watch: {
    modelValue() {
      let newInnerValue = this.modelValue;

      if (newInnerValue instanceof Array) {
        // eslint-disable-next-line prefer-destructuring
        newInnerValue = newInnerValue[0];
      }

      newInnerValue = newInnerValue ? newInnerValue.toString().replace(/^\s+/g, '') : '';

      if (newInnerValue === this.innerValue) {
        return;
      }

      this.innerValue = newInnerValue;
    },
    innerValue() {
      let newValue = this.innerValue;

      if (newValue instanceof Array) {
        // eslint-disable-next-line prefer-destructuring
        newValue = newValue[0];
      }

      newValue = newValue ? newValue.toString().replace(/^\s+/g, '') : '';

      if (newValue === this.modelValue) {
        return;
      }

      this.$emit('update:modelValue', newValue);
    },
  },
  mounted() {
    this.innerValue = this.modelValue;
  },
};

</script>

<style lang="scss" scoped>
  .input-freetext-small {
  }
</style>
